import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { jwtInterceptor } from './services/JwtInterceptor';
import { errorInterceptor } from './services/ErrorInterceptor';
import RootReducer from './reducers/RootReducer';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import './App.css';

// enable interceptors for http requests
jwtInterceptor();
errorInterceptor();
const store = createStore(RootReducer);

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <Suspense fallback={<div>Loading... </div>}>
          <App />
        </Suspense>
      </BrowserRouter>
    </React.StrictMode>
  </Provider >,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
